module.exports = __webpack_public_path__ + "static/media/plan-TH4-mobile-sc.1955910a.png";